import { useEffect, useState } from 'react'; 
import Verification from '../Verification/Verification';

function ProfileVerification() {
  
    return (
        <Verification />

    );
}

export default ProfileVerification;


